import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateStoreService } from '../services/state-store/state-store';
import { hasVendorManagementAccess } from '../utils/organization.utils';

/**
 * Allows the Vendors area when the current org is a manager / super-manager
 * org, a self-managed org, or a standard org managed by a manager.
 * Standalone STANDARD orgs are redirected away.
 *
 * Mirrors the BE `require_managed_org` predicate.
 *
 * Readiness is guaranteed by `appReadyMatch` at the route level.
 */
export const vendorAccessGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);

  const allowed = hasVendorManagementAccess(
    state.isManager(),
    state.isSuperManager(),
    state.isSelfManaged(),
    state.managedBy()
  );
  return allowed ? true : router.createUrlTree(['/assessment']);
};
